import React from 'react';

import Layout from '../../components/layout';
import Investment from '../../components/calculators/investment';

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <Investment
            pathname={pathname}
            title="Investment Calculator"
            initialInvestment={5000}
            monthlyAddition={150}
            interestRate={8}
            yearsUntilMaturity={25}
            compoundingFrequency={'monthly'}
        />
    </Layout>
);
